import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Progress,
  Stack,
  Text,
  useColorModeValue,
  Image,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  FiBarChart2,
  FiBookmark,
  FiCheckSquare,
  FiHelpCircle,
  FiHome,
  FiPenTool,
  FiCamera,
  FiSearch,
  FiSettings,
  FiUsers,
  FiShare,
  FiAtSign,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { NavButton } from "./NavButton";
import { UserProfile } from "./UserProfile";
import { CognitoUser } from "amazon-cognito-identity-js";

export const Sidebar = ({
  currentUser,
}: {
  currentUser: CognitoUser | null;
}) => {
  const navigate = useNavigate();
  const [displayUser, setDisplayUser] = useState<any | null>(null);

  useEffect(() => {
    const session = currentUser?.getSignInUserSession();
    if (session) {
      const jwtToken = session?.getIdToken().decodePayload();
      setDisplayUser({
        name: jwtToken.name,
        email: jwtToken.email,
      });
    }
  }, [currentUser]);

  return (
    <Flex as="section" minH="100vh" bg="bg-canvas">
      <Flex
        flex="1"
        bg="bg-surface"
        overflowY="auto"
        boxShadow={useColorModeValue("md", "sm-dark")}
        maxW={{ base: "full", sm: "xs" }}
        py={{ base: "2", sm: "4" }}
        px={{ base: "4", sm: "6" }}
      >
        <Stack justify="space-between" spacing="1">
          <Stack spacing={{ base: "5", sm: "6" }} shouldWrapChildren>
            <VStack>
              <Image
                maxW="50%"
                src="https://content.kydlabs.com/system/logoblack.png"
              />
              <Divider />
            </VStack>

            {/*<InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon as={FiSearch} color="muted" boxSize="5" />
            </InputLeftElement>
            <Input placeholder="Search" />
</InputGroup>*/}
            <Stack spacing="1">
              <NavButton
                onClick={() => navigate("/manager/events")}
                label="Events"
                icon={FiHome}
              />
              <NavButton
                onClick={() => navigate("/manager/admins")}
                label="Admins"
                icon={FiPenTool}
              />
              <NavButton
                onClick={() => navigate("/manager/links")}
                label="QR Codes"
                icon={FiCamera}
              />
              <NavButton
                onClick={() => navigate("/manager/bio")}
                label="Bio"
                icon={FiAtSign}
              />
              <NavButton
                onClick={() => navigate("/manager/settings")}
                label="Settings"
                icon={FiSettings}
              />
              {/*<NavButton
              label="Dashboard"
              icon={FiBarChart2}
              aria-current="page"
            />
            <NavButton label="Tasks" icon={FiCheckSquare} />
            <NavButton label="Bookmarks" icon={FiBookmark} />
<NavButton label="Users" icon={FiUsers} />*/}
            </Stack>
          </Stack>
          <Stack spacing={{ base: "5", sm: "6" }}>
            {/*<Stack spacing="1">
              <NavButton label="Help" icon={FiHelpCircle} />
              <NavButton label="Settings" icon={FiSettings} />
</Stack>*/}

            <Divider />
            {displayUser && (
              <UserProfile name={displayUser.name} email={displayUser.email} />
            )}
          </Stack>
        </Stack>
      </Flex>
    </Flex>
  );
};
